/** Canonical Firestore subcollection / doc ids (Studio schema migration). */

export const TIMELINE_DATA_SUB = 'timelineData';
export const TIMELINE_INFO_DOC_ID = '_info';
export const TIMELINE_INFO_KIND = 'info';

/** Legacy name — read fallback only until migration */
export const TIMELINE_ASSETS_SUB_LEGACY = 'timelineAssets';
export const SNAPSHOTS_SUB_LEGACY = 'snapshots';

export const PROJECT_SHARE_LINKS_SUB = 'projectShareLinks';
export const CAPTURE_SHARE_LINKS_SUB = 'captureShareLinks';
/** Legacy capture- and project-level share links */
export const CAPTURE_SHARE_LINKS_SUB_LEGACY = 'shareLinks';
export const PROJECT_SHARE_LINKS_SUB_LEGACY = 'shareLinks';
